import { getCountries, getCountryCallingCode, parsePhoneNumberFromString } from "libphonenumber-js/min";

const names = typeof Intl.DisplayNames === "function"
  ? new Intl.DisplayNames(["es"], { type: "region" }) : null;

export const PHONE_COUNTRIES = getCountries().map(id => ({
  id,
  code: `+${getCountryCallingCode(id)}`,
  name: id === "NL" ? "Países Bajos (Holanda)" : names?.of(id) || id,
  flag: String.fromCodePoint(...[...id].map(letter => 127397 + letter.charCodeAt(0))),
})).sort((a, b) => a.id === "CO" ? -1 : b.id === "CO" ? 1 : a.name.localeCompare(b.name, "es"));

export const countrySearchText = value => String(value).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

export function parseInternationalPhone(value, country = "CO") {
  const raw = String(value || "").trim();
  // Do not silently extract a different number from prose, extensions or URLs.
  if (!/^\+?[0-9\s().-]+$/.test(raw) || raw.length > 50) return null;
  try {
    const parsed = parsePhoneNumberFromString(raw.replace(/^00/, "+"), { defaultCountry: country, extract: false });
    if (!parsed || parsed.ext || !parsed.isPossible()) return null;
    let number = parsed.number;
    // WhatsApp exposes Argentine mobile identities as +54 9 ..., while a
    // generic parser treats a local Buenos Aires number (11 ...) as +54 11.
    // This application only requests WhatsApp numbers, so prefer the mobile
    // identity whenever that candidate is valid.
    if (parsed.country === "AR" && !number.startsWith("+549")) {
      const mobile = parsePhoneNumberFromString(`+549${parsed.nationalNumber}`, { extract: false });
      if (mobile?.isPossible() && mobile.isValid()) number = mobile.number;
    }
    return { number, country: parsed.country };
  } catch {
    return null;
  }
}

export function normalizeInternationalPhone(value, country = "CO") {
  return parseInternationalPhone(value, country)?.number || "";
}
